import React from "react";
import "./Testmonial.css";
import AVART1 from "../../assets/avatar1.jpg";
import AVART2 from "../../assets/avatar2.jpg";
import AVART3 from "../../assets/avatar3.jpg";
import AVART4 from "../../assets/avatar4.jpg";

// import Swiper core and required modules
import { Pagination } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

const Testmonial = () => {
  return (
    <section id="testmonial">
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>
      <Swiper
        className="container testimonials__container"
        // install Swiper modules
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        <SwiperSlide className="testmonial">
          <div className="client__avatar">
            <img src={AVART1} alt="" />
          </div>
          <h5 className="clients__name">Elona</h5>
          <small className="clients__review">
            A pleasure to work with. Responsive, knowledgeable, and creative.
            Would definitely recommend.
          </small>
        </SwiperSlide>
        <SwiperSlide className="testmonial">
          <div className="client__avatar">
            <img src={AVART2} alt="" />
          </div>
          <h5 className="clients__name">Jack</h5>
          <small className="clients__review">
            Went above and beyond to meet needs. Patient and helpful. Very happy
            with final product.
          </small>
        </SwiperSlide>
        <SwiperSlide className="testmonial">
          <div className="client__avatar">
            <img src={AVART3} alt="" />
          </div>
          <h5 className="clients__name">Jeff</h5>
          <small className="clients__review">
            Skilled web developer and great communicator. Took ideas and turned
            them into functional and visually appealing website.
          </small>
        </SwiperSlide>
        <SwiperSlide className="testmonial">
          <div className="client__avatar">
            <img src={AVART4} alt="" />
          </div>
          <h5 className="clients__name">Kate</h5>
          <small className="clients__review">
            Abubakar is a great web developer. He is reliable, efficient, and
            delivers high-quality work. I would definitely recommend him to
            others.
          </small>
        </SwiperSlide>
      </Swiper>
    </section>
  );
};

export default Testmonial;
